'use strict';


app.factory('AwsCognito', ['$http', 'localStorageService', '$rootScope', '$location', 'Popup', '$pusher', 'env_config', 'Auth', 'User',
    function ($http, localStorageService, $rootScope, $location, Popup, $pusher, env_config, Auth, User) {
        var service = {};

        service.email_regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        /**
         * Login user
         *
         * @param  string   username
         * @param  string   password
         * @param  Function callback
         */
        service.login = function (username, password, isRegister, callback) {

            if( this.reloadPageIfUserIsLogedIn() ) return;

            /**
             * change email to lowercase if username like email
             */
            cognitoUsername = username;
            if (this.email_regex.test(cognitoUsername)) {
                cognitoUsername = username.toLowerCase();
            }

            var authenticationData = {
                Username : cognitoUsername,
                Password : password
            };
            var authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);

            var poolData = {
                UserPoolId : env_config.aws.cognito.pool_id, // Your user pool id here
                ClientId : env_config.aws.cognito.pool_app_client // Your client id here
            };
            var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
            
            var userData = {
                Username : cognitoUsername,
                Pool : userPool
            };
            var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
            var self = this;
            cognitoUser.authenticateUser(authenticationDetails, {
                onSuccess: function (result) {

                    // get credentials users
                    self.getCredentials('web', result.idToken.jwtToken, function(resp) {

                        if (resp.data.error) {
                            callback(resp, 403);
                        }
                        else {
                            var verifyLoginData = {
                                access_token: result.getAccessToken().getJwtToken(),
                                refresh_token: result.getRefreshToken().getToken(),
                                id_token: result.idToken.jwtToken, 
                                cognito_identity_id: resp.data.identityId,
                                dev: 'web-app',
                                username: username
                            };

                            if (!isRegister){
                                $http.post(env_config.api_url + 'users/verify-login', verifyLoginData)
                                    .success(function (resp, status) {
                                        callback(resp, status, verifyLoginData);
                                    })
                                    .error(function(resp, status){
                                        callback(resp, status);
                                    });
                            }else {
                                callback(resp, verifyLoginData);
                            }
                        }
                    });
                },

                onFailure: function(err) {
                    var resp = {data: {error: true, message: err, httpCode: 403}} ;
                    callback(resp, 403);
                },

                newPasswordRequired: function(userAttributes, requiredAttributes) {
                    // User was signed up by an admin and must provide new
                    // password and required attributes, if any, to complete
                    // authentication.

                    // the api doesn't accept this field back
                    delete userAttributes.email_verified;

                    // Get these details and call
                    cognitoUser.completeNewPasswordChallenge("Tuiday@123", userAttributes, this);
                }

            });
        };

        /**
         * login with facebook
         * 
         * @param  String accessToken
         */
        service.fbConnect = function(fbToken, isRefresh, callback){
             var resp = {data: {message: "test"}};

            if (!isRefresh) {
                if( this.reloadPageIfUserIsLogedIn() ) return
            }

            this.getCredentials('fb', fbToken, function(resp) {
                if (resp !== undefined) {
                    if (resp.data.error) {
                        callback(resp, 500);
                        return;
                    }
                    else {
                        var fbData = {
                            'cognito_identity_id': resp.data.identityId,
                            'fbtoken': fbToken,
                            'dev': 'web-app'
                        }

                        $http.post(env_config.api_url + 'users/verify-social-connect', fbData)
                            .success(function (resp, status) {
                                callback(resp, status);
                            })
                            .error(function(resp, status){
                                callback(resp, status);
                            });
                    }
                }
            }); 

            
        }

        /**
         * if user is already logged in in another tab just reload
         * the page and use that data from local storage
         */
        service.reloadPageIfUserIsLogedIn = function(){

            var globals = localStorageService.get('globals');

            if( globals != null && typeof globals.currentUser != 'undefined'){
                Popup.error('You are already logged in as '+globals.currentUser.username+'.', function(){
                    location.reload();
                });
                return true;
            }
            return false;
        }

         /**
         * set credentials
         * 
         * @param Object user
         */
        service.setCredentials = function(data, user, credits) {
            $rootScope.globals.currentUser = user;
            $rootScope.globals.awsCredentials = data;
            $rootScope.globals.credits = credits;
            $http.defaults.headers.common['Authorization'] = 'Bearer ' + data.id_token;
            localStorageService.set('globals', $rootScope.globals);
        };

        service.getCredentials = function(type, token, callback) {
            
            var credentialsConfig;
            if (type == 'fb') {
                 credentialsConfig = {
                  IdentityPoolId: env_config.aws.cognito.identity_pool_id,
                  Logins: {
                    'graph.facebook.com': token
                  }
                };
            }
            else if (type == 'gg') {
                credentialsConfig = {
                  IdentityPoolId: env_config.aws.cognito.identity_pool_id,
                  Logins: {
                    'accounts.google.com': token
                  }
                };
            }
            else {
                var provider = 'cognito-idp.' + env_config.aws.region +'.amazonaws.com/' + env_config.aws.cognito.pool_id;
                
                credentialsConfig = {
                    IdentityPoolId: env_config.aws.cognito.identity_pool_id,
                    Logins: {}
                };
                credentialsConfig.Logins[provider] = token;
            }

            AWS.config.region = env_config.aws.region;

            AWS.config.credentials = new AWS.CognitoIdentityCredentials(credentialsConfig);
            AWS.config.credentials.clearCachedId();
            AWS.config.credentials = new AWS.CognitoIdentityCredentials(credentialsConfig);

            // Obtain AWS credentials
            AWS.config.credentials.get(function(err){
                if (err) {
                    var resp = {data: {error: true, message: err, httpCode: 403}};
                    callback(resp);
                    return;
                }
                var resp = {data: {identityId: AWS.config.credentials.identityId}};
                // store credentials into 
                $rootScope.globals.awsAccessKeyId= AWS.config.credentials.accessKeyId; 
                $rootScope.globals.awsSecretAccessKey= AWS.config.credentials.secretAccessKey;
               
                callback(resp);
            });
        };


        /**
         * verify user
         * */
        service.verifyUser = function(verifyLoginData, callback){

            $http.post(env_config.api_url + 'users/verify-login', verifyLoginData)
                .success(function (resp, status) {
                    callback(1, resp);
                })
                .error(function(resp, status){
                    callback(0, resp);
                });

        };

        // login to cognito
        service.register = function(user, callback){
            var poolData = {
                UserPoolId : env_config.aws.cognito.pool_id,
                ClientId : env_config.aws.cognito.pool_app_client
            };
            var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);

            var attributeList = [];

            var dataEmail = {
                Name : 'email',
                Value : user.email.toLowerCase() // change email to lowercase on cognito
            };

            var attributeEmail = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataEmail);

            attributeList.push(attributeEmail);

            userPool.signUp(user.username, user.password, attributeList, null, function(err, result){
                callback(err, result);
                return;

            });
        };

        /**
         * forgot password
         *
         * @param  String email
         */
        service.forgotPassword = function(username, callback){
            var poolData = {
                UserPoolId : env_config.aws.cognito.pool_id,
                ClientId : env_config.aws.cognito.pool_app_client
            };
            var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);

            /**
             * change email to lowercase if username like email
             */
            cognitoUsername = username;
            if (this.email_regex.test(cognitoUsername)) {
                cognitoUsername = username.toLowerCase();
            }

            var userData = {
                Username : cognitoUsername,
                Pool : userPool
            };
            var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

            cognitoUser.forgotPassword({
                onSuccess: function () {
                    callback(null, 1);
                    // successfully initiated reset password request
                },
                onFailure: function(err) {
                    callback(err, null);
                }        // successful response
            });
        };

        /**
         * update new password
         * */
        service.updatePassword = function(username, newpassword, verificationCode, callback){
            var poolData = {
                UserPoolId : env_config.aws.cognito.pool_id,
                ClientId : env_config.aws.cognito.pool_app_client
            };
            var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);

            /**
             * change email to lowercase if username like email
             */
            cognitoUsername = username;
            if (this.email_regex.test(cognitoUsername)) {
                cognitoUsername = username.toLowerCase();
            }

            var userData = {
                Username : cognitoUsername,
                Pool : userPool
            };
            var self = this;
            var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
            cognitoUser.confirmPassword(verificationCode, newpassword, {
                onSuccess: function(){
                    self.login(username, newpassword, false, function(resp, status, verifyLoginData){
                        callback(resp, status, verifyLoginData);
                    });
                    // successfully initiated reset password request
                },
                onFailure: function(err){
                    callback(err, null);
                }
            });
        }

        /**
         * login with facebook
         * 
         * @param  String accessToken
         */
        service.ggConnect = function(ggToken, isRefresh, ggAccessToken, callback){
            var resp = {data: {message: "test"}};

            if (!isRefresh) {
                if( this.reloadPageIfUserIsLogedIn() ) return
            }
            
            this.getCredentials('gg', ggToken, function(resp) {
                if (resp !== undefined) {
                    if (resp.data.error) {
                        callback(resp, 500);
                        return;
                    }
                    else {
                        var ggData = {
                            'cognito_identity_id': resp.data.identityId,
                            'ggtoken': ggToken,
                            'dev': 'web-app',
                            'gg_access_token': ggAccessToken
                        };

                        $http.post(env_config.api_url + 'users/verify-social-connect', ggData)
                            .success(function (resp, status) {
                                callback(resp, status);
                            })
                            .error(function(resp, status){
                                callback(resp, status);
                            });
                    }
                }
            }); 
        }

        service.checkTokenExpiration = function(callback) {
            // check login by which method.
            var awsCredentials =  $rootScope.globals.awsCredentials;
            var currentDate = Date.UTC();
            var socialToken;

            if (awsCredentials.gg_token !== undefined || awsCredentials.fb_token !== undefined) {
                // check expired social token 
                var decoded = jwt_decode(awsCredentials.id_token);
                var isExpired =  new Date(decoded.exp * 1000) < new Date();
                if ( new Date(decoded.exp * 1000) >= new Date()) {
                    callback(true);
                }
                else {
                   var type, token;
                   var self = this;
                   // refresh facebook 
                    if (awsCredentials.fb_token !== undefined) {
                        var fbData = {
                            'cognito_identity_id': $rootScope.globals.currentUser.cognito_identity_id,
                            'fbtoken': awsCredentials.fb_token,
                            'dev': 'web-app'
                        }
                        $http.post(env_config.api_url + 'users/verify-social-connect', fbData)
                            .success(function (resp, status) {
                                var cognitoData = {
                                    'id_token': resp.data.user.cognito_id_token,
                                    'fb_token': resp.data.user.fb_token
                                };
                                // success
                                self.setCredentials(cognitoData, resp.data.user);

                                User.getCredit(function(){
                                    callback(true);
                                })
                            })
                            .error(function(resp, status) {
                                callback(false, resp.data.message);
                            });
                    }
                    // refresh google
                    else if (awsCredentials.gg_token !== undefined) {
                        var ggData = {
                            'cognito_identity_id': $rootScope.globals.currentUser.cognito_identity_id,
                            'ggtoken': awsCredentials.gg_token,
                            'dev': 'web-app'
                        }

                        $http.post(env_config.api_url + 'users/verify-social-connect', ggData)
                            .success(function (resp, status) {
                                var cognitoData = {
                                    'id_token': resp.data.user.cognito_id_token,
                                    'gg_token': resp.data.user.gg_token
                                };
                                // success
                                self.setCredentials(cognitoData, resp.data.user);

                                User.getCredit(function(){
                                    callback(true);
                                })
                            })
                            .error(function(resp, status){
                                callback(false, resp.data.message);
                            });
                    }

                }
            }
            else {
                // refresh cognito email token
                var poolData = {
                    UserPoolId : env_config.aws.cognito.pool_id, // Your user pool id here
                    ClientId : env_config.aws.cognito.pool_app_client // Your client id here
                };
                var userPool = new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(poolData);
                
                var userData = {
                    Username : $rootScope.globals.currentUser.username,
                    Pool : userPool
                };
                var cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

                if (cognitoUser != null) {
                    cognitoUser.getSession(function(err, session) {
                        if (err) {
                            callback(false, err);
                        }

                        if (session.isValid()) {
                            callback(true);
                        }
                        else {
                            var self = this;
                            cognitoUser.refreshSession(sessionData.RefreshToken, function(err, session) {
                                if (err) throw err;
                                var data = {
                                    id_token: session.getIdToken().getJwtToken()
                                };
                                $http.post(env_config.api_url + '/users/' +  + '/cognito-token', data)
                                    .success(function (resp, status) {

                                        callback(true);
                                    })
                                    .error(function(resp, status){
                                        callback(resp, false);
                                    });
                            });
                        }
                    });
                }
            }
        };

        return service;
    }]);